export default {
	type: 'object',
	properties: {
		userId: { type: 'string' },
		campaignId: { type: 'string' },
		modificationValue: { type: 'number' },
	},
	required: ['userId', 'campaignId', 'modificationValue'],
	additionalProperties: false,
}
